import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { VerticalStepperLinkComponent } from '@components/molecules/forms/vertical-stepper-link/vertical-stepper-link.component';
import { ScrollService } from '@services/scroll/scroll.service';
import { Step } from '@services/scroll/steps-interface';
import { Subscription } from 'rxjs';

@Component({
    selector: 'medpace-vertical-stepper',
    standalone: true,
    imports: [VerticalStepperLinkComponent],
    templateUrl: './vertical-stepper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./vertical-stepper.component.scss'],
})
export class VerticalStepperComponent implements OnInit, OnDestroy {
    @Input()
    steps: Step[];

    @Output()
    linkClicked = new EventEmitter();

    scrollHandleSubscription: Subscription;

    navbar: HTMLElement;

    @HostListener('window:scroll', []) onWindowScroll() {
        let stepper = document.getElementById('stepper');
        let scrollTop = document.documentElement.scrollTop;

        if (scrollTop <= 25) stepper.style.transform = 'translateY(0rem)';
        else stepper.style.transform = 'translateY(-6rem)';
    }

    constructor(private scrollService: ScrollService) {}

    ngOnDestroy(): void {
        this.scrollHandleSubscription.unsubscribe();
    }

    ngOnInit(): void {
        this.scrollHandleSubscription = this.scrollService.getScrollObservable().subscribe((x) => {
            this.setStepperLevel(x);
        });

        this.navbar = document.getElementById('navbar');
    }

    stuff(event: any) {
        this.steps?.forEach((step) => {
            if (step.name === event.name) {
                step.isActive = true;
            } else {
                step.isActive = false;
            }
        });
    }

    private setStepperLevel(windowTop: number): void {
        const filteredSteps = this.steps.filter((x) => windowTop <= this.getElementStepperPosition(x.identifier));
        const currentStep = filteredSteps[0];
        if (currentStep) {
            this.steps.forEach((step) => {
                if (step.name == currentStep.name) {
                    step.isActive = true;
                } else {
                    step.isActive = false;
                }
            });
        }
    }

    private getElementStepperPosition(ObjectId: string) {
        let stepComponent: HTMLElement = document.getElementById(ObjectId);
        return stepComponent != null ? stepComponent.offsetTop : -1;
    }
}
